import { Amount, AmountProps } from '@/components/atoms/Amount/Amount'
import { motion, animate as staticAnimate, useMotionValue, useTransform } from 'framer-motion'
import { useEffect, useState } from 'react'

export const AnimatedAmount = ({
  value,
  amountProps,
  precision = 2,
  minWidth = '50px',
  duration = { rendered: 2, firstRender: 1 },
  prefix,
  suffix,
}: {
  value: number
  minWidth?: string
  precision?: number
  amountProps: Omit<AmountProps, 'value'>
  duration?: { rendered: number; firstRender: number }
  prefix?: string
  suffix?: string
}) => {
  const amount = useMotionValue(value)
  const number = useTransform(amount, (latest) => `${prefix ?? ''}${latest.toFixed(precision)}${suffix ?? ''}`)
  const [isRendered, setRendered] = useState(false)

  useEffect(() => {
    const controls = staticAnimate(amount, value, {
      duration: value === 0 ? 0 : isRendered ? duration.rendered : duration.firstRender,
    })

    !isRendered && setRendered(true)
    return controls.stop
  }, [value])

  return (
    <Amount
      {...amountProps}
      denom={amountProps.denom!}
      value={
        <motion.span
          transition={{ delay: 0.5 }}
          style={{
            minWidth,
            display: 'inline-block',
          }}
        >
          {number}
        </motion.span>
      }
    />
  )
}
